import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { getProducts, productsQueryKeys, mapApiProductToProduct } from '@api/products';
import { ApiError } from '@api/client';
import type { ProductsListParams } from '@api/products';

interface UseProductsOptions {
  enabled?: boolean;
}

export function useProducts(params?: ProductsListParams, { enabled = true }: UseProductsOptions = {}) {
  return useQuery({
    queryKey: productsQueryKeys.list(params),
    queryFn: () => getProducts(params),
    staleTime: 30_000,
    placeholderData: keepPreviousData,
    enabled,
    select: (data) => ({
      products: data.products.map(mapApiProductToProduct),
      pagination: data.pagination,
      totalUnfiltered: data.total_unfiltered,
    }),
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
